var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.5C8.97715 5.5 4.5 9.97715 4.5 15.5C4.5 21.0228 8.97715 25.5 14.5 25.5C20.0228 25.5 24.5 21.0228 24.5 15.5C24.5 9.97715 20.0228 5.5 14.5 5.5ZM2 15.5C2 8.59644 7.59644 3 14.5 3C21.4036 3 27 8.59644 27 15.5C27 22.4036 21.4036 28 14.5 28C7.59644 28 2 22.4036 2 15.5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 23.5357C18.938 23.5357 22.5357 19.938 22.5357 15.5C22.5357 11.062 18.938 7.4643 14.5 7.4643C10.062 7.4643 6.46429 11.062 6.46429 15.5C6.46429 19.938 10.062 23.5357 14.5 23.5357ZM11.8214 12.1439C11.8214 11.2899 12.7403 10.7578 13.472 11.1881L18.4197 14.0978C19.1457 14.5247 19.1457 15.5824 18.4197 16.0094L13.472 18.919C12.7403 19.3493 11.8214 18.8172 11.8214 17.9632V12.1439Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIconSelected);
export default __webpack_public_path__ + "static/media/live-icon-selected.59abac774697a973c3a45179d166ed25.svg";
export { ForwardRef as ReactComponent };